import { render, staticRenderFns } from "./PatientMessagesVueComponent.vue?vue&type=template&id=5771ec41&"
import script from "./PatientMessagesVueComponent.vue?vue&type=script&lang=ts&"
export * from "./PatientMessagesVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PatientMessagesVueComponent.vue?vue&type=style&index=0&id=5771ec41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports